import { useQuery } from '@apollo/client';
import { GetUserGroupByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import type { FC } from 'react';

type Props = {
  groupId: string | undefined;
};

const Breadcrumb: FC<Props> = ({ groupId }) => {
  if (!groupId) {
    throw new Error('Missing groupId param');
  }
  const { data } = useQuery(GetUserGroupByIdDocument, {
    variables: {
      Id: groupId,
    },
  });

  return <>{data?.user_group?.[0]?.Name || ''}</>;
};

export default Breadcrumb;
